import Resource from 'api/resource';
class DeactiveUserResources extends Resource {
  constructor() {
    super('account-deactivate/');
  }
}

export { DeactiveUserResources as default };
